module.exports = __webpack_public_path__ + "static/vr-show-39b8c0fa856b8ba20b79c9debd5af02c.jpg";